"use strict";
exports.__esModule = true;
exports.INVALID_TRYTES = 'Invalid trytes';
exports.INVALID_TRITS = 'Invalid trits';
exports.INVALID_ODD_LENGTH = 'Invalid trytes length. Expected trytes of even length.';
exports.INVALID_ASCII_CHARS = 'Invalid ascii charactes.';
//# sourceMappingURL=errors.js.map